import SearchableMultiSelectModal from '../Utilities/SearchableMultiSelectModal';
import SearchableSelectModal from '../Utilities/SearchableSelectModal';
import React from 'react';

interface ISelectModalProps {
    filterName: string,
    onSelect: (filterName: string, value: any) => void,
    title: string,
    displayText?: string,
    options: any,
    currentSelection?: any,
    mutliSelect: boolean,
    searchable: boolean,
    isAgentName?: boolean,
    activeAgentFlagHandler?: (boolean) => void,
    isSentiment?: boolean
    isAgent?: boolean
}

export class SelectModal extends React.Component<ISelectModalProps> {
    constructor(props) {
        super(props);
    }

    public handleSelect = (value: any) => {
        this.props.onSelect(this.props.filterName, value);
    }

    public render() {
        if (this.props.mutliSelect) {
            if (this.props.isAgentName) {
                return <SearchableMultiSelectModal title={this.props.title} currentSelection={this.props.currentSelection} onSelect={this.handleSelect} options={this.props.options} text={this.props.displayText} searchable={this.props.searchable} isAgentName={this.props.isAgentName} activeAgentFlagHandler={this.props.activeAgentFlagHandler} isAgent={this.props.isAgent} />
            }
            if (this.props.isSentiment) {
                return <SearchableMultiSelectModal title={this.props.title} currentSelection={this.props.currentSelection} onSelect={this.handleSelect} options={this.props.options} text={this.props.displayText} searchable={this.props.searchable} activeAgentFlagHandler={this.props.activeAgentFlagHandler} isSentiment />
            }
            return <SearchableMultiSelectModal title={this.props.title} currentSelection={this.props.currentSelection} onSelect={this.handleSelect} options={this.props.options} text={this.props.displayText} searchable={this.props.searchable}/>
        }
        else {
            return <SearchableSelectModal title={this.props.title} currentSelection={this.props.currentSelection} onSelect={this.handleSelect} options={this.props.options} text={this.props.displayText} searchable={this.props.searchable} />
        }
    }
}